import { useEffect, useMemo, useState } from 'react';

type WeightedItem = {
  id: string;
  name: string;
  weight: number;
  originalWeight?: number;
};

export function useFlowLanderOfferSelection(params: {
  landers: WeightedItem[];
}) {
  const { landers } = params;
  const [selectedLanderId, setSelectedLanderId] = useState<string | null>(null);

  useEffect(() => {
    if (landers.length <= 0) {
      setSelectedLanderId(null);
      return;
    }
    if (selectedLanderId && landers.some((l) => l.id === selectedLanderId)) return;
    setSelectedLanderId(landers.find((l) => l.weight > 0)?.id ?? landers[0].id);
  }, [landers, selectedLanderId]);

  const selectedLanderName = useMemo(() => {
    if (!selectedLanderId) return undefined;
    return landers.find((l) => l.id === selectedLanderId)?.name;
  }, [landers, selectedLanderId]);

  return {
    selectedLanderId,
    setSelectedLanderId,
    selectedLanderName,
  };
}

